import { Button, Stack, Typography } from "@mui/material";
import WushTextField from "../../form/WushTextField";
import { useState } from "react";
import payCash from "../../../api/auth/orders/payCash";
import useOrderStore from "../../../stores/useOrderStore";

export default function CashCheckout({ order }) {
  const [ cashCollected, setCashCollected ] = useState(0);

  const { updateOrder } = useOrderStore();

  const onSubmit = () => {
    payCash(order.id, cashCollected, (response) => {
      updateOrder(response);
    });
  };

  console.log(order);

  return (
    <Stack>
      <Stack>
        <Typography variant="h5">
          Amount due: ${order.total_price_with_fees_dollars}
        </Typography>
      </Stack>
      <Stack mb={2}>
        <Typography variant="body1">
          Please collect ${order.total_price_with_fees_dollars} in cash from the customer.
        </Typography>
      </Stack>
      <Stack>
        <WushTextField
          formRegistration={{ onChange: (event) => setCashCollected(event.target.value) }}
          label="Cash collected"
          type="number"
        />
      </Stack>
      <Stack mb={2}>
        {cashCollected >= order.total_price_with_fees_dollars ? <Stack>
          <Typography variant="h6">
            Change: ${cashCollected - order.total_price_with_fees_dollars}
          </Typography>
        </Stack> :
        cashCollected ? <Stack>
          <Typography variant="h6" color="red">
            Short: ${order.total_price_with_fees_dollars - cashCollected}
          </Typography>
        </Stack> : null}
      </Stack>
      <Stack>
        <Button
          disabled={cashCollected && cashCollected < order.total_price_with_fees_dollars}
          variant="contained" color="primary"
          onClick={onSubmit}
        >
          Confirm Payment
        </Button>
      </Stack>
    </Stack>
  );
}